import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { pageTranslation, field } from "../app/schema";

export const GET_PAGES_TRANSLATION = "GET_PAGES_TRANSLATION";
export const GET_PAGES_TRANSLATION_SUCCESS = "GET_PAGES_TRANSLATION_SUCCESS";
export const GET_PAGES_TRANSLATION_ERROR = "GET_PAGES_TRANSLATION_ERROR";

export const GET_PAGES_TRANSLATION_BY_UID = "GET_PAGES_TRANSLATION_BY_UID";
export const GET_PAGES_TRANSLATION_BY_UID_START = "GET_PAGES_TRANSLATION_BY_UID_START";
export const GET_PAGES_TRANSLATION_BY_UID_SUCCESS = "GET_PAGES_TRANSLATION_BY_UID_SUCCESS";
export const GET_PAGES_TRANSLATION_BY_UID_ERROR = "GET_PAGES_TRANSLATION_BY_UID_ERROR";

export const POST_PAGES_TRANSLATIONS = "POST_PAGES_TRANSLATIONS";
export const POST_PAGES_TRANSLATIONS_SUCCESS = "POST_PAGES_TRANSLATIONS_SUCCESS";
export const POST_PAGES_TRANSLATIONS_ERROR = "POST_PAGES_TRANSLATIONS_ERROR";

export const PATCH_PAGES_TRANSLATION = "PATCH_PAGES_TRANSLATION";
export const PATCH_PAGES_TRANSLATION_SUCCESS = "PATCH_PAGES_TRANSLATION_SUCCESS";
export const PATCH_PAGES_TRANSLATION_ERROR = "PATCH_PAGES_TRANSLATION_ERROR";

export const DELETE_PAGES_TRANSLATION = "DELETE_PAGES_TRANSLATION";
export const DELETE_PAGES_TRANSLATION_SUCCESS = "DELETE_PAGES_TRANSLATION_SUCCESS";
export const DELETE_PAGES_TRANSLATION_ERROR = "DELETE_PAGES_TRANSLATION_ERROR";

export const POST_PAGES_TRANSLATION_FIELDS = "POST_PAGES_TRANSLATION_FIELDS";
export const POST_PAGES_TRANSLATION_FIELDS_SUCCESS = "POST_PAGES_TRANSLATION_FIELDS_SUCCESS";
export const POST_PAGES_TRANSLATION_FIELDS_ERROR = "POST_PAGES_TRANSLATION_FIELDS_ERROR";

export const SET_IS_EDIT_PAGE_TRANSLATION_MEDIA_FIELD_MODAL_VISIBLE = "SET_IS_EDIT_PAGE_TRANSLATION_MEDIA_FIELD_MODAL_VISIBLE";
export const SET_IS_ADD_PAGE_TRANSLATION_MODAL_VISIBLE = "SET_IS_ADD_PAGE_TRANSLATION_MODAL_VISIBLE";
export const SET_IS_REMOVE_PAGE_TRANSLATION_MODAL_VISIBLE = "SET_IS_REMOVE_PAGE_TRANSLATION_MODAL_VISIBLE";

export const SET_IS_EDIT_PAGE_TRANSLATION_MODAL_VISIBLE = "SET_IS_EDIT_PAGE_TRANSLATION_MODAL_VISIBLE";

// Validation
const validateForm = {
  createPageTranslation: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createPageTranslationField: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const getPagesTranslationGet = (fetch, apiHost, accessToken, slug) =>
  fetch(`${apiHost}/v1/pages-translation/${slug}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const getPagesTranslationByUidGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages-translations/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postPagesTranslations = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/pages-translations`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {
      duplicate: {
        field: "all",
        msg: "Slug nie może się powtarzać"
      }
    });
  });

const patchPagesTranslation = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/pages-translations/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {
      duplicate: {
        field: "all",
        msg: "Slug nie może się powtarzać"
      }
    });
  });

const deletePagesTranslation = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages-translations/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych tłumaczenia strony, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getPagesTranslationFieldsGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages-translations/${uid}/fields`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postPagesTranslationFields = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/pages-translations/${uid}/fields`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions

export function getPagesTranslation(slug) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_TRANSLATION],
    payload: {
      promise: getPagesTranslationGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        slug
      )
        .then(data => {
          return normalize(data, pageTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        slug
      }
    }
  });
}

export function getPagesTranslationByUid(uid, slug) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES_TRANSLATION_BY_UID],
    payload: {
      promise: getPagesTranslationByUidGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, pageTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid,
      slug
    }
  });
}

export function createPagesTranslation(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_PAGES_TRANSLATIONS],
    payload: {
      promise: validateForm
        ["createPageTranslation"](validate, data)
        .then(() =>
          postPagesTranslations(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, pageTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updatePagesTranslation(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_PAGES_TRANSLATION],
    payload: {
      promise: patchPagesTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, pageTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removePagesTranslation(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_PAGES_TRANSLATION],
    payload: {
      promise: deletePagesTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function createPagesTranslationField(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_PAGES_TRANSLATION_FIELDS],
    payload: {
      promise: validateForm
        ["createPageTranslationField"](validate, data)
        .then(() =>
          postPagesTranslationFields(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, field);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsEditPageTranslationMediaFieldModalVisible(value) {
  return {
    type: SET_IS_EDIT_PAGE_TRANSLATION_MEDIA_FIELD_MODAL_VISIBLE,
    data: {
      isVisible: value
    }
  };
}

export function setIsAddPageTranslationModalVisible(value) {
  return {
    type: SET_IS_ADD_PAGE_TRANSLATION_MODAL_VISIBLE,
    data: {
      isVisible: value
    }
  };
}

export function setIsRemovePageTranslationModalVisible(value) {
  return {
    type: SET_IS_REMOVE_PAGE_TRANSLATION_MODAL_VISIBLE,
    data: {
      isVisible: value
    }
  };
}

export function setIsEditPageTranslationModalVisible(value) {
  return {
    type: SET_IS_EDIT_PAGE_TRANSLATION_MODAL_VISIBLE,
    data: {
      isVisible: value
    }
  };
}

// Standard functions
export function validateFormFieldPagesTranslations(form, name, value) {
  const feature = "pagesTranslations";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/pageTranslations/actions.js